/**
 *
 * @param str String to paragraph-ize
 */
export const formatMultilineText = (str: string): string =>
    str
        .split(/\n\n/g)
        .map((value) => `<p>${value}</p>`)
        .join("");
